"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesV1 = void 0;
var FeaturesV1 = /** @class */ (function () {
    function FeaturesV1(data) {
        this.tracking = data.tracking;
        this.analysis = data.analysis;
        this.notifications = data.notifications;
    }
    FeaturesV1.prototype.getTracking = function () {
        return this.tracking;
    };
    FeaturesV1.prototype.getAnalysis = function () {
        return this.analysis;
    };
    FeaturesV1.prototype.getNotifications = function () {
        return this.notifications;
    };
    return FeaturesV1;
}());
exports.FeaturesV1 = FeaturesV1;
//# sourceMappingURL=features.js.map